export default "__VITE_ASSET__Cty5cf4b__"